package com.vizio.pay.api

import com.vizio.redwolf.pay.api.AccountRewardsApi
import com.vizio.redwolf.pay.api.AccountRewardsResult
import com.vizio.redwolf.pay.model.RewardsRequestInfo
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.PayEnvironment
import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import kotlin.js.Promise

@JsExport
class AccountRewardsJsApi(env: PayEnvironment, jsClientConfig: JsClientConfig? = null) {
    private val accountRewardsApi = AccountRewardsApi(environment = env,
                                                      appConfig = AppConfig(""),
                                                      clientConfig = jsClientConfig.toClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS)
    )

    @JsName("requestRewards")
    fun requestRewards(jsRequestInfo: dynamic): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleAccountRewardsJsException) {
            val requestInfo = RewardsRequestInfo(
                pageNumber = jsRequestInfo.pageNumber as Int?,
                pageSize = jsRequestInfo.pageSize as Int?,
                accessToken = jsRequestInfo.accessToken as String
            )
            accountRewardsApi.requestRewards(requestInfo)
        }
    }

    private fun <T: Any> handleAccountRewardsJsException(ex: Exception, data: JsExceptionInfo<T>? = null): AccountRewardsResult.Error {
        return AccountRewardsResult.Error(ResponseHeaders.Invalid, Exception(jsRequestExceptionError))
    }

}
